import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Backdrop, CircularProgress } from "@mui/material";
import { getCategorias } from "../../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import CategoriasHeader from "./components/CategoriasHeader";
import CategoriasTableComponent from "./components/CategoriasTableComponent";


function ObsequiosCategoriasPage() {
    const [loading, setLoading] = useState(false);
    const [dataCategorias, setDataCategorias] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);
    const [loadingCargar, setLoadingCargar] = useState(false);




    let history = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.body?.token);


    useEffect(() => {
        if (stateToken) {
            handleApiFiltrarCategorias(1);
        }
    }, [stateToken, perPage]);







    //=============================================funcion para editar
    const handleEditClick = (id, row) => () => {
        // console.log('Edit', id, row);
        history('/app/admin/obsequios/categoria-detalle/' + id, {
            state: { data: row }
        });
    };






    const handleAddCategoria = () => {
        history('/app/admin/obsequios/categoria-add');
    }


    //=============================================funcion para editar
    const handleEditarItem = (item) => {
        console.log('Edit', item);
        history('/app/admin/obsequios/categoria-detalle/' + item.id, {
            state: { data: item }
        });
    };


    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };


    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarCategorias = (page = 1) => {

        let body = {
            page: page,
            per_page: perPage,
            // estado: statusFilter,
            titulo: ""
        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getCategorias(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarEventos", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataCategorias(response.data);
                    setLoading(true);
                } else {
                    setDataCategorias([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getCategorias", error);
                setDataCategorias([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };




    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div className="max-w-7xl mx-auto">

                        <CategoriasHeader
                            title="Categorías"
                            subtitle="Administra y supervisa las categorías de la plataforma."
                            handleAdd={handleAddCategoria}
                        />





                        <div>
                            <CategoriasTableComponent
                                data={dataCategorias}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarCategorias}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditarItem}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />
                        </div>



                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}


                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>

            </div>
        </HeaderCustom>
    );
}

export default ObsequiosCategoriasPage;